import * as BABYLON from 'babylonjs';

class Converter
{
    name = "Babylonjs";

    convertPositionFromCMS( p ) {
        var v = new BABYLON.Vector3( p.x, p.y, -1.0 * p.z );
        v = v.rotateByQuaternionToRef(BABYLON.Quaternion.RotationAxis( BABYLON.Vector3.Up(), Math.PI ), v );
        return v;
    }

    convertRotationFromCMS( r ) {
        //console.log("Converting rotation " + JSON.stringify(r));
        if( !isNaN(r) ) {
            let result = BABYLON.Quaternion.FromEulerAngles(0, r ? r * Math.PI /180 + 90*Math.PI / 180: 90*Math.PI / 180, 0 );
            //console.log(" = (Euler) > " + JSON.stringify(result ));
            return result;
        }
        else {
            //console.log(" => " + r );
            return r;
        }
    }
}

const instance = new Converter();
Object.freeze(instance);

export default instance;
